import script from "./TitlePreviewSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./TitlePreviewSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./TitlePreviewSkeleton.vue?vue&type=style&index=0&id=90795818&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90795818"]])

export default __exports__